import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import FieldSet from 'flarum/common/components/FieldSet';
import ThemeMode from 'flarum/common/components/ThemeMode';

/**
 * «Цветовая схема» (/color-scheme): only the theme picker, moved here from core «Настройки»
 * (same preference colorScheme, saved at once like in core; the section is hidden there).
 */
export default class ColorSchemePage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.session.user) {
      m.route.set(app.route('index'));
      return;
    }
    this.loading = false;
    this.show(app.session.user);
    app.setTitle(app.translator.trans('ppk2-profile.forum.color_scheme.title'));
  }
  content() {
    const user = this.user;
    if (!user) return null;
    const current = user.preferences()?.colorScheme;
    return m("div", {
      className: "Ppk2ColorSchemePage"
    }, m(FieldSet, {
      className: "Settings-colorScheme FieldSet--min FieldSet--col",
      label: app.translator.trans('ppk2-profile.forum.color_scheme.title')
    }, app.allowUserColorScheme ? ThemeMode.colorSchemes.map(mode => m(ThemeMode, {
      mode: mode.id,
      label: mode.label || app.translator.trans('core.forum.settings.color_schemes.' + mode.id.replace('-', '_') + '_mode_label'),
      selected: current === mode.id,
      loading: this.loading,
      onclick: () => {
        this.loading = true;
        user.savePreferences({
          colorScheme: mode.id
        }).then(() => {
          this.loading = false;
          app.setColorScheme(mode.id);
          m.redraw();
        }, () => {
          this.loading = false;
          m.redraw();
        });
      }
    })) : m("p", {
      className: "helpText"
    }, app.translator.trans('ppk2-profile.forum.color_scheme.disabled'))));
  }
}
flarum.reg.add('ppk2-profile', 'forum/components/ColorSchemePage', ColorSchemePage);